<script setup lang="ts">
import { type ItemType } from '@components/util/faq/FaqList.vue';

defineProps<IProps>();
const contentStore = useContentStore();
interface IProps {
    title: string;
    items?: ItemType[];
}

const FaqList = defineAsyncComponent(
    () => import('@components/util/faq/FaqList.vue')
);
const isLoading = computed(() => contentStore.searchResultContentsLoading);
</script>
<template>
    <div v-if="!isLoading && items?.length" class="faq-container">
        <div class="container">
            <h2>{{ title }}</h2>
            <FaqList :items class="content" :limit="4" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.faq-container {
    padding-top: 28px;
    @include mobile-only {
        padding: 4px 8px 0;
        margin-top: -66px;
        h2 {
            text-align: right !important;
        }
    }
    .container {
        background-color: white;
        border-radius: 12px;
        padding: 20px;
        @include shadow();
    }
}
</style>
